import React from 'react';
import { useTranslation } from "react-i18next";
import Card from "react-bootstrap/Card";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

const Policy = () => {
   const { t, i18n } = useTranslation();
   const basePath = i18n.language === "en" ? "/en" : "";
    return (
       <div className="policy-conditions">
          <Helmet>
             <title>Política de privacidad | Joan Company</title>
             <meta
                name="description"
                content="Información sobre la política de privacidad y tratamiento de datos en Joan Company."
             />
             <link
                rel="alternate"
                href="https://www.joancompany.es/politica-privacidad"
                hreflang="es"
             />
             <link
                rel="alternate"
                href="https://www.joancompany.es/en/politica-privacidad"
                hreflang="en"
             />
          </Helmet>
          <div className="policy-conditions-container">
             <h1>{t("privacy_policy")}</h1>
             <h2>{t("last_update")}</h2>
          </div>
          <div className="page-breadcrumb">
             <Link to={`${basePath}/`} title="Home">
                {t("home")}
             </Link>{" "}
             <span>/</span>
             <span>{t("privacy_policy")}</span>
          </div>
          <Card
             className="quote-card-view"
             id="service-info-card"
             data-aos="fade-up"
             data-aos-duration="2000"
          >
             <Card.Body>
                <div className="policy-conditions-content">
                   <div
                      dangerouslySetInnerHTML={{ __html: t("privacy_content") }}
                   />
                </div>
             </Card.Body>
          </Card>
       </div>
    );
};

export default Policy;